import React, { useEffect, useState } from 'react';
import styles from './SurveySearchPage.module.css';
import apiClient from '../../../api/apiClient';
const client = apiClient('survey');

function ParticipantSelector({
  queryParams,
  setQueryParams,
  selectedParticipants,
  participantSearch,
  setParticipantSearch,
  showParticipantDropdown,
  setShowParticipantDropdown,
}) {
  const [availableStartups, setAvailableStartups] = useState([]);

  // Fetch available participants on component mount
  useEffect(() => {
    client
      .get('/surveys/list/startups')
      .then((response) => {
        setAvailableStartups(response.data);
      })
      .catch((error) => {
        console.error('Error fetching participants:', error);
      });
  }, []);

  const filteredParticipants = availableStartups
    .filter(
      (participant) =>
        participant.toLowerCase().includes(participantSearch.toLowerCase()) &&
        !selectedParticipants.includes(participant)
    )
    .sort();

  const handleParticipantAdd = (participant) => {
    if (!queryParams.participant.includes(participant)) {
      setQueryParams((prev) => ({
        ...prev,
        participant: [...prev.participant, participant],
      }));
    }
    setParticipantSearch('');
    setShowParticipantDropdown(false);
  };

  const handleParticipantRemove = (participant) => {
    setQueryParams((prev) => ({
      ...prev,
      participant: prev.participant.filter((p) => p !== participant),
    }));
  };

  const handleParticipantSearchChange = (value) => {
    setParticipantSearch(value);
    setShowParticipantDropdown(true);
  };

  return (
    <div>
      <label className={styles.label} style={{ gridColumn: '1 / -1' }}>
        Participants:
      </label>
      <div style={{ gridColumn: '1 / -1' }}>
        {selectedParticipants.length > 0 && (
          <div className={styles.selectedParticipants}>
            {selectedParticipants.map((participant) => (
              <span key={participant} className={styles.participantTag}>
                {participant}
                <button
                  onClick={() => handleParticipantRemove(participant)}
                  className={styles.removeBtn}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
        <div className={styles.participantSearchWrapper}>
          <div className={styles.flexRow}>
            <input
              type="text"
              placeholder="Search and select participants..."
              value={participantSearch}
              onChange={(e) => handleParticipantSearchChange(e.target.value)}
              onFocus={() => setShowParticipantDropdown(true)}
              onBlur={() =>
                setTimeout(() => setShowParticipantDropdown(false), 200)
              }
              className={styles.input}
              style={{ width: '100%' }}
            />
          </div>
          {showParticipantDropdown &&
            participantSearch &&
            filteredParticipants.length > 0 && (
              <div className={styles.participantDropdown}>
                {filteredParticipants.slice(0, 20).map((startup) => (
                  <div key={startup} style={{ display: 'flex' }}>
                    <div
                      onClick={() => {
                        handleParticipantAdd(startup + '_E');
                        handleParticipantAdd(startup + '_R');
                      }}
                      className={styles.participantDropdownItem}
                      style={{ flex: 1, borderRight: '1px solid #eee' }}
                    >
                      {startup}
                    </div>
                    <div
                      onClick={() => handleParticipantAdd(startup + '_E')}
                      className={styles.participantDropdownItem}
                      style={{ flex: 1, borderRight: '1px solid #eee' }}
                    >
                      {startup}_E
                    </div>
                    <div
                      onClick={() => handleParticipantAdd(startup + '_R')}
                      className={styles.participantDropdownItem}
                      style={{ flex: 1 }}
                    >
                      {startup}_R
                    </div>
                  </div>
                ))}
                {filteredParticipants.length > 20 && (
                  <div className={styles.participantDropdownMore}>
                    ... and {filteredParticipants.length - 20} more. Keep typing
                    to narrow results.
                  </div>
                )}
              </div>
            )}
        </div>
        <small className={styles.helpText}>
          Type to search participants, click to add. Selected:{' '}
          {selectedParticipants.length}
        </small>
      </div>
    </div>
  );
}

export default ParticipantSelector;
